import React, { useEffect, useState } from 'react';
import './MatureContent.scss';
import { hideScroll, showScroll } from '../../utils/utils';
import KodanshaCheckBox from '../KodanshaUIKit/KodanshaCheckBox/KodanshaCheckBox';
import KodanshaUnderlinedText from '../KodanshaUIKit/KodanshaUnderlinedText/KodanshaUnderlinedText';
import KodanshaArrow from '../KodanshaUIKit/KodanshaArrow/KodanshaArrow';
import { useAtom } from 'jotai';
import { MatureContentVisible } from '../../store/OverlayStore';
import { useHistory } from 'react-router-dom';
import { MatureContentWarningAccepted } from '../../store/AccountStore';
import KodanshaSubmit from '../KodanshaUIKit/KodanshaSubmit/KodanshaSubmit';

const MatureContent = (): JSX.Element => {
    const [active, setActive] = useState(false);
    const [, setMatureContentVisible] = useAtom(MatureContentVisible);
    const [matureContentWarningAccepted, SetMatureContentWarningAccepted] = useAtom(MatureContentWarningAccepted);



    const history = useHistory();

    useEffect(() => {
        setTimeout(() => {
            hideScroll();
        }, 100);

        return (): void => {
            showScroll();
        };
    }, []);

    const onModalClicked = (e): void => {
        e.stopPropagation();
        if (e.target === e.currentTarget) {
            // setMatureContentVisible(false);
        }
    };

    const onCloseClicked = (e): void => {
        e.stopPropagation();
        history.goBack();
    };

    const onAcceptClicked = (e): void => {
        if (active) {
            SetMatureContentWarningAccepted(true);
        }
    };

    return (
        <div className='mature-content-container' onClick={onModalClicked} onWheel={e => e.stopPropagation()}>
            <div className='mature-content-modal'>
                <h3 className='mature-content-title'>Mature Content</h3>
                <div className='mature-divider' />


                <span className='mature-text'>This series may contain violence, sex, nudity or strong language not suitable for some audiences.</span>

                <div className='mature-checkbox-wrapper'>
                    <KodanshaCheckBox onChange={() => setActive(active => !active)} checked={active}
                                      label={'Yes, I\'m willing to view mature content.'} />

                    <KodanshaSubmit text={'Confirm'} styles={'mature-checkbox-submit'} onSubmitClicked={onAcceptClicked}/>
                </div>

                <div className='mature-divider' />

                <div className='mature-actions-wrapper'>
                    <KodanshaUnderlinedText text={'CLOSE READER'} onClick={onCloseClicked} />
                    {/*<KodanshaArrow withArrow={false} text={'Confirm'} active={active}*/}
                    {/*               onClick={onAcceptClicked} />*/}
                </div>


            </div>
        </div>
    );
};

export default MatureContent;
